/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goals_On_GoInputs */

const en_onboarding_goals_on_go = /** @type {(inputs: Onboarding_Goals_On_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen while on the Go`)
};

const es_onboarding_goals_on_go = /** @type {(inputs: Onboarding_Goals_On_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchar mientras camino`)
};

/**
* | output |
* | --- |
* | "Listen while on the Go" |
*
* @param {Onboarding_Goals_On_GoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_goals_on_go = /** @type {((inputs?: Onboarding_Goals_On_GoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goals_On_GoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_goals_on_go(inputs)
	return en_onboarding_goals_on_go(inputs)
});